/**
 * Script Purpose:
 * A customer requested disabling the preselection of the ‘Size’ option in the 
 * `Shoes` product's category. However, due to limitations in Shopify and the 
 * purchased theme:
 *
 * - We cannot change the `selected_or_first_available_variant` (within Shopify) 
 * variant.
 * - We cannot rewrite the existing theme logic to handle options without risking 
 * breaking other functionality.
 *
 * Solution:
 * - This script is added as a non-invasive enhancement to the theme.
 * - It works together with removing the `selected` class from "Size" options 
 * via Liquid and ensures Add-to-Cart buttons remain disabled until users manually 
 * select all the options (including 'Size').
 * - This approach avoids impacting other options or breaking the core theme logic.
 *
 * Functionality:
 * - Detects if all required options have a selection.
 * - Disables the Add-to-Cart button until all required options are explicitly 
 * selected.
 * - Works without altering the theme’s existing option handling logic.
 */
document.addEventListener('DOMContentLoaded', () => {
  const optionsWrapper = document.querySelector('[js-options-wrapper]')
  const optionButtonGroups =
    optionsWrapper?.querySelectorAll('[js-option-button-group]') || []
  const addToCartButtons = document.querySelectorAll('[js-add-to-cart]')
  const hasOptionsButtons = Array.from(optionButtonGroups).every((group) =>
    Boolean(group.querySelector('[js-option-button]'))
  )

  if (
    !optionsWrapper ||
    !hasOptionsButtons ||
    optionButtonGroups.length === 0 ||
    addToCartButtons.length === 0
  ) {
    return
  }

  optionsWrapper.addEventListener('click', () => {
    /**
     * If all selected - do nothing and let the other theme.js logic manage the
     * `disabled state
     */
    if (areAllOptionsSelected(optionButtonGroups)) {
      return
    }

    disableAddToCart(addToCartButtons)
  })

  /**
   * Checks if all option button groups have a selected option.
   * @param {NodeListOf<HTMLElement>} buttonGroups - List of option button groups.
   * @returns {boolean} - True if all button groups have a selected option.
   */
  function areAllOptionsSelected(buttonGroups) {
    return Array.from(buttonGroups).every((group) =>
      Boolean(group.querySelector('[js-option-button].selected'))
    )
  }

  /**
   * Disables all Add-to-Cart buttons.
   * @param {NodeListOf<HTMLElement>} buttons - List of Add-to-Cart buttons.
   */
  function disableAddToCart(buttons) {
    buttons.forEach((button) => button.setAttribute('disabled', 'disabled'))
  }
})
